import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import './NACHDetailsPage.css'

import { formatDate, formatAmount } from './NACHDetailsPageUI'

const NACHSendEmailModalUI = ({
  context,
  isOpen,
  mandate,
  account,
  onSubmit,
  onCancel,
  busy
}) => {
  if (!isOpen || !mandate) return null

  const bank = mandate.bankDetails || {}
  const companyName = (account && account.accountName) || mandate.accountId || 'Client'

  return (
    <ModalFormUI
      context={context}
      titleLabel='Confirm NACH Registration Email Submission'
      buttonLabel={busy ? 'Sending...' : 'Send Email'}
      cancelLabel='Cancel'
      isOpen={isOpen}
      onRequestClose={onCancel}
      onSubmit={onSubmit}
      busy={busy}
    >
      <div className='g_m_bottom_100'>
        <p>Are you sure you want to send the NACH registration package to Worldline for this mandate?</p>
        <div className='nach-modal-details-box'>
          <div style={{ marginBottom: '6px' }}>
            <b>URN:</b> <span className='g_m_left_50'>{mandate.urn}</span>
          </div>
          <div style={{ marginBottom: '6px' }}>
            <b>Account:</b> <span className='g_m_left_50'>{companyName}</span>
          </div>
          <div style={{ marginBottom: '6px' }}>
            <b>Mandate Amount:</b> <span className='g_m_left_50'>{formatAmount(mandate.amount)}</span>
          </div>
          <div style={{ marginBottom: '6px' }}>
            <b>Bank Details:</b>{' '}
            <span className='g_m_left_50'>
              {bank.accountNumber || '-'} ({bank.bankName || '-'}, IFSC: {bank.ifsc || '-'})
            </span>
          </div>
          <div style={{ marginBottom: '6px' }}>
            <b>Start Date:</b> <span className='g_m_left_50'>{formatDate(mandate.startDate)}</span>
          </div>
          <div style={{ marginBottom: '6px' }}>
            <b>End Date:</b> <span className='g_m_left_50'>{formatDate(mandate.endDate)}</span>
          </div>
        </div>
        <p className='nach-modal-subtext'>
          <strong>Attachments included:</strong>
          <br />1. NACH Mandate Form
          <br />2. NACH Registration Details File (.xlsx)
        </p>
        <p className='nach-modal-note'>
          * Sending this email will automatically update the mandate stage to <strong>Submitted</strong> and record the submission date.
        </p>
      </div>
    </ModalFormUI>
  )
}

export default NACHSendEmailModalUI
